import { Tooltip, withStyles } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import styles from './Autorating.module.scss';
const FeedbackTooltip = ({ error_msg = '' }) => {
  const TooltipCustom = withStyles(() => ({
    tooltip: {
      backgroundColor: 'black',
      color: 'white',
    },
    arrow: {
      color: 'black',
    },
    tooltipPlacementTop: {
      margin: '0.4rem 0',
    },
  }))(Tooltip);

  if (error_msg)
    return (
      <TooltipCustom
        arrow
        title={<div>{error_msg || `Answer can not be rated by AI at the moment `}</div>}
        placement="top"
        className={styles.enableTooltip}
      >
        <HelpOutline style={{ fontSize: '1rem' }} />
      </TooltipCustom>
    );

  return (
    <div className={styles.container}>
      <div>Feedback</div>
      <TooltipCustom
        arrow
        title={<div>Rating and feedback has been generated by AI</div>}
        placement="top"
        className={styles.enableTooltip}
      >
        <HelpOutline style={{ fontSize: '1rem' }} />
      </TooltipCustom>
    </div>
  );
};

export default FeedbackTooltip;
